import { handleActions } from "redux-actions";

import {
	getRulesListAsyncAction,
	getRuleDetailAsyncAction,
	updateRuleAsyncAction,
	deleteRuleAsyncAction,
	postRuleAsyncAction,
	resetAction,
} from "./rulesActions";

const defaultAjaxState = {
	response: null,
	error: null,
	loading: false,
};

const initialState = {
	list: defaultAjaxState,
	post_rule: defaultAjaxState,
	update_rule: defaultAjaxState,
	rule_detail: defaultAjaxState,
	delete_rule: defaultAjaxState,
};

export const rulesReducer = handleActions(
	new Map([
		// get rule list
		[
			getRulesListAsyncAction.request,
			(state, { payload }) => ({
				...state,
				list: {
					...initialState.list,
					loading: true,
				},
			}),
		],
		[
			getRulesListAsyncAction.success,
			(state, { payload }) => ({
				...state,
				list: {
					...initialState.list,
					response: payload,
				},
			}),
		],
		[
			getRulesListAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				list: {
					...initialState.list,
					error: payload,
				},
			}),
		],

		// get rule detail
		[
			getRuleDetailAsyncAction.request,
			(state, { payload }) => ({
				...state,
				rule_detail: {
					...initialState.rule_detail,
					loading: true,
				},
			}),
		],
		[
			getRuleDetailAsyncAction.success,
			(state, { payload }) => ({
				...state,
				rule_detail: {
					...initialState.rule_detail,
					response: payload,
				},
			}),
		],
		[
			getRuleDetailAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				rule_detail: {
					...initialState.rule_detail,
					error: payload,
				},
			}),
		],

		// post rule detail
		[
			postRuleAsyncAction.request,
			(state, { payload }) => ({
				...state,
				post_rule: {
					...initialState.post_rule,
					loading: true,
				},
			}),
		],
		[
			postRuleAsyncAction.success,
			(state, { payload }) => ({
				...state,
				post_rule: {
					...initialState.post_rule,
					response: payload,
				},
			}),
		],
		[
			postRuleAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				post_rule: {
					...initialState.post_rule,
					error: payload,
				},
			}),
		],

		// put rule detail
		[
			updateRuleAsyncAction.request,
			(state, { payload }) => ({
				...state,
				update_rule: {
					...initialState.update_rule,
					loading: true,
				},
			}),
		],
		[
			updateRuleAsyncAction.success,
			(state, { payload }) => ({
				...state,
				update_rule: {
					...initialState.update_rule,
					response: payload,
				},
			}),
		],
		[
			updateRuleAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				update_rule: {
					...initialState.update_rule,
					error: payload,
				},
			}),
		],

		// put rule detail
		[
			deleteRuleAsyncAction.request,
			(state, { payload }) => ({
				...state,
				delete_rule: {
					...initialState.delete_rule,
					loading: true,
				},
			}),
		],
		[
			deleteRuleAsyncAction.success,
			(state, { payload }) => ({
				...state,
				delete_rule: {
					...initialState.delete_rule,
					response: payload,
				},
			}),
		],
		[
			deleteRuleAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				delete_rule: {
					...initialState.delete_rule,
					error: payload,
				},
			}),
		],

		// reset
		[
			resetAction,
			(state, { payload }) => ({
				...state,
				[payload]: initialState[payload],
			}),
		],
	]),
	initialState
);
